export class DBValueDistributionResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<ColumnValueDistribution>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DBValueDistributionResponse.attributeTypeMap;
    }
    constructor() {
    }
}
